import type { AiDraftMode } from './types';

/** What each way of asking is called on its button and on the sheet's title. */
export const AI_DRAFT_MODES: Record<AiDraftMode, string> = {
  write: 'Ayuda a redactar con IA',
  fix: 'Corregir ortografía',
  shorten: 'Acortar',
  formal: 'Formalizar',
  friendly: 'Más cercano',
};

/** The ones that go over what is already written, in the order of the buttons. */
export const AI_REVIEW_MODES: readonly AiDraftMode[] = ['fix', 'shorten', 'formal', 'friendly'];

/** The back keeps a request ten minutes; a proposal still not there after three is not coming. */
export const AI_DRAFT_PATIENCE_MS = 180_000;
